import React, { useState } from 'react';
import { useHistory, useLocation } from 'react-router';
import axios from 'axios';
import Cookies from 'universal-cookie';
import { ToastContainer } from 'react-toastify';
import { Alert } from '../../services/Alert';

import { useAuth } from '../../auth/useAuth';

const cookies = new Cookies();

export const LoginPage = () => {
    
    const auth = useAuth();
    
    const history = useHistory();
    const location = useLocation();
    const prevObjectUrl = location.state?.from;

    const [state, setState] = useState({
        form:{
            LoginUser:'',
            LoginPass:'',
        },
        error:false,
        errorMsg:''
    });

    const handleLogin = (e) => {
        e.preventDefault();

        const getData = async() => {
            const config = JSON.parse(localStorage.getItem('config'));
            const BaseUrl = config.baseUrl || 'http://localhost/wservices/';
            const AppId = config.appId ||'';
            
            try{
                //console.log(state);
                const data = {
                    apikey: AppId || '',
                    action: 'login',
                    provider: 'proveedor',
                    data: {
                        tkid: '', 
                        user: state.form.LoginUser, 
                        password: state.form.LoginPass 
                    }
                }
                
                await axios.post(BaseUrl, data)
                .then(response => {
                    return response.data
                })
                .then(datos => {
                    
                    if((datos.type || '') === ''){
                        Alert('Advertencia: No hubo respuesta del servidor','warning',{});
                        return;
                    }
                    
                    //Ya tenemos una respuesta valida, ahora la procesamos
                    if(datos.type === 'error'){
                        Alert('Advertencia: '+ datos.code + ' - ' + datos.message,'warning',{});
                        return;
                    }
                    
                    const resultado = datos.data || {};
                    
                    const userdata = {
                        usuario: resultado.usuario || '',
                        descripcion: resultado.descripcion || '',
                        tabla: resultado.tabla || '',
                        clave: resultado.clave || '',
                        login: true
                    }

                    localStorage.setItem('usprovdb',JSON.stringify(userdata));
                    cookies.set('pvckid',resultado.tkid, { path: '/' });
                    auth.login();
                    
                    if(!auth.isLogged()){
                        //setError('Login correcto: ' + auth.isLogged());
                        history.push(prevObjectUrl || '/');
                    }else{
                        Alert('Datos de usuario no validos: ' + auth.isLogged(),'warning',{});
                    }

                }).catch(error => {
                    Alert('Error: '+error.message,'error',{});
                });
            }catch(error){
                Alert('Error: '+error.message,'error',{});
            }
        }

        getData();
        
    }

    const handleChange = async (evt) => {
        const value = (evt.target.type === "checkbox" || evt.target.type === "radio") ? evt.target.checked : evt.target.value;
        setState({
            form:{
                ...state.form,
                [evt.target.name]: value
            }
        });
    }

    return (
        <div className="container">
            <div className="row">
                <div className="col-md-4 offset-md-4">
                    <div className="login-form mt-4 p-4">
                        <form onSubmit={handleLogin} className="row g-3">
                            <h4 className="text-center m8-h1">Iniciar sesión</h4>
                            <div className="col-12">
                                <label className="m8-ilabel-s">Usuario:</label>
                                <input type="text" name="LoginUser" className="form-control m8-itext" placeholder="Usuario" onChange={handleChange} />
                            </div>
                            <div className="col-12">
                                <label className="m8-ilabel-s">Contraseña:</label>
                                <input type="password" name="LoginPass" className="form-control m8-itext" placeholder="Contraseña"  onChange={handleChange}/>
                            </div>
                            <div className="col-12">
                                <div className="form-check">
                                    <input className="form-check-input m8-itext" type="checkbox" name="LoginRemember" id="LoginRemember"  onChange={handleChange}/>
                                    <label className="form-check-label m8-ilabel" htmlFor="LoginRemember"> Recuerdame</label>
                                </div>
                            </div>
                            <div className="col-12 text-center">
                                <button type="submit" className="btn ps-5 pe-5 btn-sm float-center m8-btn-submit">Acceder</button>
                            </div>
                        </form>
                        <hr className="mt-4" />
                        <div className="col-12">
                            <p className="text-center mb-0 m8-text">¿No tienes una cuenta? <a href="/">Contactanos</a></p>
                        </div>
                    </div>
                </div>
            </div>
            <ToastContainer />
        </div>                              
    )
}
